export default __webpack_public_path__ + "static/media/siemens-logo-petrol.6feef1b1.svg";